import { gql } from "@apollo/client";

export const ProfileContract = gql`
  query ProfileContract {
    profile {
      id
      client {
        id
        contract {
          id
          contractDurationFrom
          contractDurationTo
        }
      }
    }
  }
`;